import { Component, OnInit } from '@angular/core';
import {
  PAGE_SIZE,
  MAX_SIZE,
  CURRENCY_SYB,
} from 'src/app/onelog/common/config/common';
import { environment } from 'src/environments/environment';
import { RequestService } from 'src/app/onelog/services/request.service';
import {
  DEFAULT_SELECTED_OPTION_TYPE_TOTAL_ROYALTY_PRODUCT,
  DEFAULT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT,
  SELECT_TYPE_DROP_DOWN_OPTIONS,
  SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS,
  DEFAULT_CONTRACT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT,
  DROP_DOWN_SETTING_BOOKTYPE,
} from 'src/app/onelog/common/config/dropdown-config';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { TOTAL_ROYALTY_PRODUCT } from 'src/app/onelog/common/config/url';
import { ProductSatusService } from 'src/app/onelog/services/product-status.service';
import { DevMyTitleService } from 'src/app/onelog/services/dev-my-title.service';

@Component({
  selector: 'app-total-royalty-product',
  templateUrl: './total-royalty-product.component.html',
  styleUrls: ['./total-royalty-product.component.css'],
})
export class TotalRoyaltyProductComponent implements OnInit {
  apiURL = environment.sachWebURL;
  selectedproductId: string = '';
  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 0;
  showSearchLoading: boolean = false;
  pageSize: number = PAGE_SIZE;
  maxSize: number = MAX_SIZE;
  Currency: any = CURRENCY_SYB;
  searchBtnText: string = 'Search';
  selectedStatusFilterType: string = 'equal to';
  selectedContractStatusFilterType: string = 'equal to';
  selectedStatusType: any = [];
  selectedContractStatusType: any = [];
  responseData: any = [];
  selectTypeDropDownOptions: any = SELECT_TYPE_DROP_DOWN_OPTIONS;
  selectStatusTypeDropDownOptions: any = SELECT_STATUS_TYPE_DROP_DOWN_OPTIONS;
  DefaultselectedOptionType: string =
    DEFAULT_SELECTED_OPTION_TYPE_TOTAL_ROYALTY_PRODUCT;
  dropdownSettingsBookType: IDropdownSettings = {};
  selectedDefaultItemsStatus: any =
    DEFAULT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT;
  dropdownListBookStatus: any = [];
  dropdownListContractStatus: any = [];
  selectContractStatusTypeDropDownOptions: any =
    DEFAULT_CONTRACT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT;
  selectedStatusFilter: any = [];
  selectedContractStatusFilter: any = [];
  publishedDateSelectedFilterData: any = [];
  alphaPublishedDateSelectedFilterData: any = [];
  ProductStatusList: any = [];
  contractStatusList: any = [];

  constructor(
    private _requestService: RequestService,
    private _productStatus: ProductSatusService
  ) {}

  ngOnInit(): void {
    this.loadProductStatusList();
    this.loadContractStatusList();

    this.dropdownSettingsBookType = DROP_DOWN_SETTING_BOOKTYPE;

    this.loadProducts(this.createPostData());
  }

  loadProducts(postData: any = [], url: string = TOTAL_ROYALTY_PRODUCT) {
    return this._requestService
      .postRequest(url, postData)
      .subscribe((data: {}) => {
        this.responseData = data;
        this.products = this.responseData.data;
        this.totalProducts = this.responseData.total;
        this.perPage = this.responseData.per_page;
        this.lastPage = this.responseData.last_page;
        this.currentPage = this.responseData.current_page;
        console.log(data);
        this.searchBtnText = 'Search';
        this.showSearchLoading = false;
      });
  }

  createPostData() {
    this.setStatusFilterData();

    return {
      selectedAlphaPublishedDate: Object.assign(
        {},
        this.alphaPublishedDateSelectedFilterData
      ),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
      selectedStatus: Object.assign({}, this.selectedStatusFilter),
      selectedContractStatus: Object.assign(
        {},
        this.selectedContractStatusFilter
      ),
    };
  }

  setStatusFilterData() {
    if (
      this.selectedStatusFilterType !== null &&
      this.selectedStatusType.length > 0
    ) {
      console.log('in status');
      this.selectedStatusFilter['selectedFilterType'] =
        this.selectedStatusFilterType;
      this.selectedStatusFilter['selected'] = this.selectedStatusType;
    }

    if (
      this.selectedContractStatusFilterType !== null &&
      this.selectedContractStatusType.length > 0
    ) {
      console.log('in contract status');
      this.selectedContractStatusFilter['selectedFilterType'] =
        this.selectedContractStatusFilterType;
      this.selectedContractStatusFilter['selected'] =
        this.selectedContractStatusType;
    }

    console.log(this.selectedStatusFilter, this.selectedContractStatusFilter);
  }

  setSearching() {
    this.showSearchLoading = true;
  }

  unsetSearching() {
    this.showSearchLoading = false;
  }

  downloadReport() {
    this.setStatusFilterData();

    this._requestService.download(
      TOTAL_ROYALTY_PRODUCT,
      {
        is_download: 1,
        selectedAlphaPublishedDate: Object.assign(
          {},
          this.alphaPublishedDateSelectedFilterData
        ),
        selectedPublishedDate: Object.assign(
          {},
          this.publishedDateSelectedFilterData
        ),
        selectedStatus: Object.assign({}, this.selectedStatusFilter),
        selectedContractStatus: Object.assign(
          {},
          this.selectedContractStatusFilter
        ),
      },
      '',
      'TOTAL_ROYALTY_PRODUCT'
    );
    // let urlParams = '?is_download=1'

    // this._requestService.download('/derivative_source_product,'',urlParams,'derivative_source_product-'+ new Date().toLocaleString() + '.csv')
  }

  searchProduct() {
    this.searchBtnText = 'Searching...';
    this.showSearchLoading = true;

    console.log({
      selectedAlphaPublishedDate: Object.assign(
        {},
        this.alphaPublishedDateSelectedFilterData
      ),
      selectedPublishedDate: Object.assign(
        {},
        this.publishedDateSelectedFilterData
      ),
      selectedStatus: Object.assign({}, this.selectedStatusFilter),
      selectedContractStatus: Object.assign(
        {},
        this.selectedContractStatusFilter
      ),
    });

    this.setStatusFilterData();

    this.loadProducts(this.createPostData());
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    //console.log(eventData);
    let urlParams = '?page=' + eventData.currentPage;
    this.loadProducts(
      this.createPostData(),
      `${TOTAL_ROYALTY_PRODUCT}${urlParams}`
    );
  }

  updateSelectedType(event: any) {
    console.log('mm', event);

    if (event.name == 'alphaPublishedDate') {
      this.alphaPublishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }

    if (event.name == 'publishedDate') {
      this.publishedDateSelectedFilterData['selectedFilterType'] =
        event.selectedOption;
    }

    if (event.name == 'status') {
      this.selectedStatusFilterType = event.selectedOption;
    }

    if (event.name == 'contractStatus') {
      this.selectedContractStatusFilterType = event.selectedOption;
    }
  }

  updateSelectedDate(event: any) {
    //console.log(event);

    if (event.type == 'publishedDate') {
      this.publishedDateSelectedFilterData['date'] = event.dateString;
    }

    if (event.type == 'alphaPublishedDate') {
      this.alphaPublishedDateSelectedFilterData['date'] = event.dateString;
    }
  }

  updateSelectedDropDown(event: Event) {
    const data: any = event;

    if (data.type == 'contractStatus') {
      if (data.action == 'selected') {
        this.selectedContractStatusType.push(data.item.item_text);
      } else {
        const index = this.selectedContractStatusType.indexOf(
          data.item.item_text
        );
        this.selectedContractStatusType.splice(index, 1);
      }
      if (data.action == 'deSelectedAll') {
        this.selectedContractStatusType = ['contracted'];
        this.selectContractStatusTypeDropDownOptions =
          DEFAULT_CONTRACT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT;
      }
    }

    if (data.type == 'bookStatus') {
      console.log(data.action);
      if (data.action == 'selected') {
        this.selectedStatusType.push(data.item.item_text);
      } else {
        const index = this.selectedStatusType.indexOf(data.item.item_text);
        this.selectedStatusType.splice(index, 1);
      }
      if (data.action == 'deSelectedAll') {
        this.selectedStatusType = ['Published'];
        this.selectedDefaultItemsStatus =
          DEFAULT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT;
      }
    }
  }

  loadProductStatusList() {
    //this.showLoader = true;
    return this._productStatus.getStatusList().subscribe((data: {}) => {
      this.ProductStatusList = data;
      let statusList: any = [];
      let selectedStatusList: any = [];
      let defaultStatusList: any =
        DEFAULT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT;
      let tempSelectedDd: any = [];
      this.ProductStatusList.data.forEach(function (
        currentValue: any,
        index: any,
        arr: any
      ) {
        let obj: any = {};
        obj['item_id'] = currentValue.attributes.name;
        obj['item_text'] = currentValue.attributes.name;
        statusList.push(obj);
        //statusList = '';
        //console.log(currentValue);

        if (defaultStatusList.includes(currentValue.attributes.name)) {
          selectedStatusList.push(obj);
          tempSelectedDd.push(currentValue.attributes.name);
        }
      });
      //console.log(selectedStatusList);
      this.dropdownListBookStatus = statusList;
      //this.showLoader = false;
      this.selectedDefaultItemsStatus = selectedStatusList;
      this.selectedStatusType = tempSelectedDd;

      this.loadProducts(this.createPostData());
      //this.showLoader = false;
    });
  }

  loadContractStatusList() {
    this.contractStatusList = [
      { item_id: 'new', item_text: 'new' },
      { item_id: 'contracted', item_text: 'contracted' },
      { item_id: 'cancelled', item_text: 'cancelled' },
    ];
    //console.log('contract status data');console.log(contractStatusList);
    let selectedContractStatusList: any = [];
    let defaultContractStatusList: any =
      DEFAULT_CONTRACT_SELECTED_STATUS_TOTAL_ROYALTY_PRODUCT;
    let tempSelectedCd: any = [];
    let contractList: any = [];

    this.contractStatusList.forEach(function (
      currentValue: any,
      index: any,
      arr: any
    ) {
      let obj1: any = {};
      obj1['item_id'] = currentValue.item_id;
      obj1['item_text'] = currentValue.item_id;
      contractList.push(obj1);
      //statusList = '';
      //console.log('me',currentValue.item_id);

      if (defaultContractStatusList.includes(currentValue.item_id)) {
        selectedContractStatusList.push(obj1);
        tempSelectedCd.push(currentValue.item_id);
      }
    });

    this.dropdownListContractStatus = contractList;
    //console.log('status data');console.log(selectedContractStatusList);
    //this.showLoader = false;
    this.selectContractStatusTypeDropDownOptions = selectedContractStatusList;
    this.selectedContractStatusType = tempSelectedCd;

    this.loadProducts(this.createPostData());
  }
}
